import { Phone, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/lib/siteData";

const StickyBar = () => (
    <div
        data-testid="mobile-bottom-bar"
        className="fixed bottom-0 inset-x-0 z-50 md:hidden grid grid-cols-2 border-t border-amber-500/20 bg-[#0B132B]/95 backdrop-blur"
    >
        <a
            href={BUSINESS.tel1}
            data-testid="mobile-call-button"
            aria-label="Call Shubham Housing now"
            className="flex items-center justify-center gap-2 py-4 text-sm font-bold bg-amber-400 text-[#0B132B] active:bg-amber-300"
        >
            <Phone size={16} /> Call Now
        </a>
        <a
            href={BUSINESS.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-whatsapp-button"
            aria-label="Chat with Shubham Housing on WhatsApp"
            className="flex items-center justify-center gap-2 py-4 text-sm font-bold bg-[#25D366] text-[#062b16] active:bg-[#1EBE57]"
        >
            <MessageCircle size={16} /> WhatsApp
        </a>
    </div>
);

export default StickyBar;
